import styled from 'styled-components'
import checkIcon from '../../../../../assets/icons/check-icon.svg'

export const YearsFilter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 !important;
`

export const YearItem = styled.span`
  font-size: 2rem;
  line-height: 120%;
  margin: 0 .75rem;
  color: #DADADA;
  cursor: pointer;
  ${props => props.selected && `
    color: #01878E;
  `}
`

export const MonthsContainer = styled.div`
  justify-content: center;
  display: flex;
  margin: 1.5rem 0;
`

export const MonthsFilter = styled.div`
  display: flex;
  overflow-x: auto;
  max-width: 100vw;
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`

export const MonthItem = styled.div`
  display: inline-flex;
  align-items: center;
  font-family: 'Open Sans';
  font-size: .75rem;
  text-transform: capitalize;
  margin: 0 .5rem;
  color: #555555;
  padding: 6px 12px;
  border: 1px solid #777777;
  border-radius: 1rem;
  cursor: pointer;
  &:first-child {
    margin-left: 1rem;
  }
  &:last-child {
    margin-right: 1rem;
  }

  ${props => props.selected && `
    color: #01878E;
    border-color: #01878E;
    background-color: #E0F8F9;
    &::before {
      content: '';
      display: block;
      width: 18px;
      height: 14px;
      background: url(${checkIcon}) no-repeat center;
      margin-right: 7px;
    }
  `}
`
